// extracted by mini-css-extract-plugin
export var banner = "_s5-0";
export var settingRow = "_s5-2";
export var titleIcon = "_s5-1";